import React from 'react';
import styled from 'styled-components';

import NavigationBar from '@components/navigation-bar';

import { Management } from './components/Management';

const ManagementContainer = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
`;

const ManagementPage = () => {
  return (
    <ManagementContainer>
      <NavigationBar />
      <Management />
    </ManagementContainer>
  );
};

export default ManagementPage;
